import React, { useCallback, useEffect, useMemo } from 'react'
import { PurchaseMarketSection } from '../../../PurchaseMarketSection'
import { createStaticPurchaseMarketService } from '../../../PurchaseMarketSection/StaticPurchaseMarketService'
import { useAnalysisMode } from '../../contexts/AnalysisModeContext'
import { useAnalysisServices } from '../../contexts/AnalysisServicesContext'
import { useAnalysisMapSectionData } from '../../contexts/MapSectionDataContext'

/**
 * Shared PurchaseMarketTab used by both main and public apps.
 *
 * - Main app: gets purchaseMarketService from
 *   getSectionData('purchaseMarketService')
 * - Public app: creates static service from entity
 *   market_aggregations data
 */
export const PurchaseMarketTab: React.FC = () => {
  const { entity, userId, readOnly } = useAnalysisMode()
  const { getSectionData, updateSectionData } = useAnalysisServices()
  const { setActiveSection } = useAnalysisMapSectionData()

  useEffect(() => {
    setActiveSection('purchase_market')
  }, [setActiveSection])

  const service = useMemo(() => {
    if (readOnly) {
      const marketData =
        entity?.market_aggregations ||
        entity?.marketAggregations ||
        entity?.purchase_market ||
        null
      return createStaticPurchaseMarketService(marketData)
    }
    return getSectionData('purchaseMarketService')
  }, [readOnly, entity, getSectionData])

  // Read saved filters from entity
  const savedFilters = entity?.purchaseMarketFilters

  const handleFilterChange = useCallback(
    (filters: any) => {
      if (!entity || !userId) return
      updateSectionData('purchaseMarket', entity, userId, { filters })
    },
    [entity, userId, updateSectionData]
  )

  if (!service || !entity) return null

  return (
    <PurchaseMarketSection
      entity={entity}
      service={service}
      readOnly={readOnly}
      initialLocationType={savedFilters?.locationType}
      initialPropertyType={savedFilters?.propertyType}
      onFilterChange={readOnly ? undefined : handleFilterChange}
    />
  )
}
